export {
    Type,
    JSON,
    Err,
    ErrorType,
    toCBOR,
    fromCBOR,
    registerCBOREncoder,
    registerCBORDecoder,
    zero,
    create,
    equals,
    toDecimal,
    fromDecimal,
    instanceOf,
    fromJSON,
} from '../../plt/TokenAmount.js';
